import styled from 'styled-components';
import Colors from '../../../../../config/Colors';

export const ExcludeTimeButton = styled.div`
    height: 28px;
    display: flex;
    flex-direction: row;
    white-space: nowrap;
    justify-content: center;
    align-items: center;
    background-color: ${Colors.lighter};
    border-radius: 4px;
    border: 1px solid ${Colors.border};
    padding: 1px 6px;
    margin: 5px;

    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;

export const ExcludeTimeText = styled.span`
    font-size: 1.4rem;
    margin: 0 10px 0 5px;
    display: flex;
    flex: 7;
    color: ${Colors.dark};
    font-family: NunitoSans-Regular;
`;

export const ExcludeTextX = styled.span`
    align-self: center;
    font-family: NunitoSans-Regular;
    font-size: 1.4rem;
    color: ${Colors.dark};
`;

export const ExcludeTimeIcon = styled.button`
    flex: 2;
    height: 25px;
    width: 25px;
    margin: 0;
    padding: 0;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    border: none;

    &:hover {
        border: 1px solid ${Colors.border};
        background-color: ${Colors.border};
        cursor: pointer;
    }
`;
